var _defs, _path, _circle, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.73 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#f2f2f2;}.cls-1,.cls-2{opacity:0.31;}.cls-2{fill:#ccc;}.cls-3{opacity:0.53;}.cls-11,.cls-12,.cls-4,.cls-7{stroke:#fff;}.cls-11,.cls-12,.cls-13,.cls-14,.cls-4,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-5{font-size:28.93px;font-family:CircularStd-Bold, Circular Std;font-weight:700;}.cls-5,.cls-8{fill:gray;}.cls-6{opacity:0.46;}.cls-7{fill:#fff;}.cls-8{stroke:#e6e6e6;}.cls-12,.cls-9{fill:#b3b3b3;}.cls-10{opacity:0.62;}.cls-11{fill:#999;}.cls-12{stroke-width:0.5px;}.cls-13,.cls-14{fill:none;stroke-width:0.25px;}.cls-13{stroke:#878484;}.cls-14{stroke:#848080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.33,91.32l1.06-.1a7.88,7.88,0,0,1,3.32-.45c1.39.09,2.78.14,4.17.2s3,.11,4.56.21c2.72.09,5.44.14,8.16.17,14.48-.62,28.82-2,43.23-.91a51.16,51.16,0,1,0-64.5.88Z",
    transform: "translate(-266.39 0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 83.88,
    cy: 51.19,
    r: 38.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.17,90.13c2.33.07,4.66.21,7,.4,2.69-.06,5.37-.1,8.05-.14a13.39,13.39,0,1,0-15-.26Z",
    transform: "translate(-266.39 0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(109.81 86.75) rotate(-0.2)"
  }, "+"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 83.89,
    cy: 53.54,
    r: 23.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M373.44,57.28c-5.54,4.83-11.24,5.52-13.16,3.43s-.09-6.56.17-7.21c-2.54-1.21-3.06-2.24-3.08-3,0-1.6,2.51-2,4-5.36.41-.9.45-1.38,1-1.84,1.27-1,2.76,0,4-.66.8-.4,1.71-1.52,1.81-5A20.66,20.66,0,0,1,370,39.9a21.44,21.44,0,0,1,3.42,8.72A24.61,24.61,0,0,1,373.44,57.28Z",
    transform: "translate(-266.39 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M334.52,71.23c7.34.46,12.27-2.47,12.53-5.29s-3.93-5.26-4.53-5.62c1.27-2.51,1.06-3.64.64-4.21-1-1.29-3.24-.09-6.46-1.8-.87-.46-1.2-.81-1.94-.82-1.62,0-2.21,1.66-3.61,1.93-.88.18-2.28-.16-4.46-2.83a19.73,19.73,0,0,0-.05,2.78,21.6,21.6,0,0,0,2.6,9A24.85,24.85,0,0,0,334.52,71.23Z",
    transform: "translate(-266.39 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M345.2,39.37a8.52,8.52,0,0,1-2.85,6.79,7.84,7.84,0,0,1-6.81,1.66,7.08,7.08,0,0,1-3.36-2.14c0-1.57-.17-3.67-1.19-4-1.38-.51-3.37,2.44-3.65,2.23s2.35-6.26,8.32-10.34c2.62-1.79,5.13-3.51,8.08-2.77,3.27.83,4.87,4.14,5.23,4.94Z",
    transform: "translate(-266.39 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M363.29,73.32a18.27,18.27,0,0,1-6.09,2.93,13.55,13.55,0,0,1-6.65.41,12,12,0,0,1-3.62-1.39,3.36,3.36,0,0,1-2-1.59,2.87,2.87,0,0,1-.27-2.47c.86-1.6,4.13-.75,4.56-2,.3-.86-1.2-1.64-.92-2.6s2.46-1.58,4-1.32c3.9.65,5.42,6.46,5.5,6.76Z",
    transform: "translate(-266.39 0)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.78,21.05a34.3,34.3,0,0,0-7.54,6.27,57.07,57.07,0,0,0-6.35,9.2h0a74.15,74.15,0,0,0-10.61-1.13,39.29,39.29,0,0,0-10.73,1.44q-3-5.09-6.07-10.15L311.39,8.75Z",
    transform: "translate(-266.39 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "53.86 5.92 28.1 27.28 0.86 31.63 26.62 10.27 53.86 5.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 26.74,
    y1: 17.91,
    x2: 53.67,
    y2: 5.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 57.28,
    y1: 13.07,
    x2: 53.67,
    y2: 5.66
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleImage2);
export default __webpack_public_path__ + "static/media/TitleImage2.d907d05a06e38a3c8a62c2220b894fff.svg";
export { ForwardRef as ReactComponent };